import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import FinancialSimulator from './pages/FinancialSimulator';
import AgreementManagement from './pages/AgreementManagement';
import DocumentRepository from './pages/DocumentRepository';
import WithdrawalForms from './pages/WithdrawalForms';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-white" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Login data-id="element-4" />} data-id="element-3" />
          <Route path="/dashboard" element={<Dashboard data-id="element-6" />} data-id="element-5" />
          <Route path="/simulator" element={<FinancialSimulator data-id="element-8" />} data-id="element-7" />
          <Route path="/agreements" element={<AgreementManagement data-id="element-10" />} data-id="element-9" />
          <Route path="/repository" element={<DocumentRepository data-id="element-12" />} data-id="element-11" />
          <Route path="/withdrawals" element={<WithdrawalForms data-id="element-14" />} data-id="element-13" />
          <Route path="/reports" element={<Reports data-id="element-16" />} data-id="element-15" />
          <Route path="/profile" element={<Profile data-id="element-18" />} data-id="element-17" />
        </Routes>
      </div>
    </BrowserRouter>;
}